export default __webpack_public_path__ + "static/media/signum-de.00f2932e.png";